/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



const engraveInputs = document?.querySelectorAll('input[data-engrave]')
const engravePropertyAnchor = document?.querySelector('div[data-engrave-property-anchor]');
const engraveContainer = document?.querySelector('div[data-engrave-container]');
const engraveField = engraveContainer?.querySelector('input[data-engrave-field]');
const characterLimit = engraveContainer?.dataset.characterLimit
const characterCount = engraveContainer?.querySelector('span[data-character-count]');
const remainingCharacters = engraveContainer?.querySelector('span[data-remaining-characters]');
const acceleratedCheckout = document?.querySelector('shopify-accelerated-checkout')
const showEngraveField = (e) => {
    engraveContainer.classList.remove('hidden');
    engravePropertyAnchor.innerHTML = `<input data-engrave-property type="hidden" name="properties[Engraving]">`
    updateCheckoutState('show');
}

const hideEngraveField = (e) => {
    if (engraveContainer.classList.contains('hidden')) return;
    engraveField.value = '';
    engravePropertyAnchor.innerHTML = '';
    remainingCharacters.textContent = characterLimit;
    engraveContainer.classList.add('hidden');
    updateCheckoutState('hide');
}

engraveField?.addEventListener('input', function(event) {
    const engraveProperty = document?.querySelector('input[data-engrave-property]');
    if (engraveProperty) {
        engraveProperty.value = event.target.value;
        engraveField.value.length > 0 ? characterCount?.classList?.remove('hidden') : characterCount?.classList?.add('hidden');
        remainingCharacters.textContent = characterLimit - event.target.value.length;
    }
});

engraveInputs?.forEach(input => {
    if (input.checked && input.value === 'Engraved') {
       showEngraveField('show');
    } else {
       hideEngraveField('hide');
    }

    input.addEventListener('change', function(event) {
        event.target.value === 'Engraved' ? showEngraveField('show') : hideEngraveField('hide');
    });
});


function updateCheckoutState(state) {
    if (!acceleratedCheckout) return;
  
    if (state === 'show' && engraveField.value.length < 1) {
      // Disable accelerated checkout
      acceleratedCheckout.style.pointerEvents = 'none';
      acceleratedCheckout.style.opacity = '0.5';
      acceleratedCheckout.setAttribute('aria-disabled', 'true');
    } else {
      // Enable accelerated checkout
      acceleratedCheckout.style.pointerEvents = '';
      acceleratedCheckout.style.opacity = '';
      acceleratedCheckout.removeAttribute('aria-disabled');
    }
  }
  
  // Run on page load
    const isEngravedSelected = Array.from(engraveInputs || []).some(input => input.checked && input.value === 'Engraved');
    updateCheckoutState(isEngravedSelected ? 'show' : 'hide');
  
  // Also run on input
  engraveField.addEventListener('input', updateCheckoutState);

